import { render, staticRenderFns } from "./seeMailBaoSi.vue?vue&type=template&id=257046c8&scoped=true"
import script from "./seeMailBaoSi.vue?vue&type=script&lang=js"
export * from "./seeMailBaoSi.vue?vue&type=script&lang=js"
import style0 from "./seeMailBaoSi.vue?vue&type=style&index=0&id=257046c8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "257046c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('257046c8')) {
      api.createRecord('257046c8', component.options)
    } else {
      api.reload('257046c8', component.options)
    }
    module.hot.accept("./seeMailBaoSi.vue?vue&type=template&id=257046c8&scoped=true", function () {
      api.rerender('257046c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/claim/customerRecordManage/modelForm/seeMailBaoSi.vue"
export default component.exports